import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ColumnConfig } from './header-config.model';

@Component({
  selector: '[carehub-table-header]',
  imports: [CommonModule, TableModule],
  templateUrl: './table-header.component.html',
  styleUrl: './table-header.component.scss',
})
export class TableHeaderComponent {
  @Input() config: ColumnConfig[] = [];

  @Output() sortingChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  /**
   * Sort the table by a specific column property
   *
   * @param property string
   * @returns void
   */
  sortBy(clickedHeader: ColumnConfig): void {
    if (!clickedHeader || !clickedHeader.sortable) {
      return; // Column not found
    }

    // Toggle the sort order
    clickedHeader.sort = clickedHeader.sort === 'asc' ? 'desc' : 'asc';

    this.sortingChange.emit(this.createSortArray());
  }

  /**
   * Create an array of sort strings based on the current selection
   *
   * @returns string[]
   */
  createSortArray(): string[] {
    return this.config
      .filter((col: ColumnConfig) => col.sort)
      .map((col: ColumnConfig) => `${col.field}:${col.sort}`);
  }
}
